/// <amd-module name="VSSUI/Utils/CustomizedScreenSize" />
import * as React from "react";
import { ScreenContext, ScreenSize } from "VSSUI/Utils/CustomizedScreen";
import { Observer } from "VSSUI/Observer";

export interface IScreenSizeConditionalProps {
    condition: (screenSize: ScreenSize) => boolean;
}

export const CustomizedScreenSizeObserver = (props: any) => {
    return <ScreenContext.Consumer>{screen => <Observer screenSize={screen.size}>{props.children}</Observer>}</ScreenContext.Consumer>;
};

/**
 * Conditionally renders children based on screen size.
 */
export const ScreenSizeConditional: React.FunctionComponent<IScreenSizeConditionalProps> = props => {
    return (
        <CustomizedScreenSizeObserver>
            {(screenSizeProps: { screenSize: ScreenSize }) => props.condition(screenSizeProps.screenSize) && props.children}
        </CustomizedScreenSizeObserver>
    );
};
